import type { BaseSizes } from '../types/BaseTheme';
import space from './space';

const sizes: BaseSizes = {
  space,
  checkout: {
    innerMaxWidth: 640,
  },
};

export default sizes;
